import { useEffect, useRef, useContext } from "react" 

import { Play, Loader2 } from "lucide-react" 

import { ReplayTerminalContext } from '../context/ReplayTerminalContext'

import '../../workspace/css/workspace.scss'

export default function ReplayTerminal({ height }) {
  const { terminalOutput, isRunning } = useContext(ReplayTerminalContext)

  const scrollRef = useRef(null)
  
  // 1. Auto-scroll when output changes
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight
    }
  }, [terminalOutput])

  return (
    <div className="ws-terminal-panel" style={{ height: height ? `${height}px` : '100%' }}>
      {/* Visual Resizer Strip */}
      <div className="ws-resizer ws-vertical" />
      
      <div className="ws-terminal-controls">
        <div className="ws-controls-left">
          {/* 2. Reactive Run Button */}
          <button 
            className={`ws-run-button ${isRunning ? 'ws-running' : ''}`}
            style={{ 
                cursor: 'default', 
                pointerEvents: 'none',
                opacity: isRunning ? 0.7 : 1 
            }}
            tabIndex={-1}
          >
            {isRunning ? (
                <>
                    <Loader2 className="ws-icon-sm ws-spin" />
                    Running...
                </>
            ) : (
                <>
                    <Play className="ws-icon-sm" /> 
                    Run Tests
                </>
            )}
          </button>
        </div>
      </div>

      <div className="ws-terminal-output" ref={scrollRef}>
        <div className="ws-output-content">
          {terminalOutput.length === 0 && !isRunning && (
              <span style={{opacity: 0.5}}>Waiting for execution...</span>
          )}
          
          {terminalOutput.map((line, index) => (
             <div key={index} className={`terminal-line ${line.type}`}>
               {line.content} 
             </div>
          ))}
        </div>
      </div>
    </div>
  )
}